import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CloseButtonComponent } from "../../buttons/close-button/close-button.component";
import { CancelButtonComponent } from '../../buttons/cancel-button/cancel-button.component';

@Component({
  selector: 'app-cancel-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule, CloseButtonComponent, CancelButtonComponent],
  templateUrl: './cancel-modal.component.html',
  styleUrl: './cancel-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CancelModalComponent {
  readonly label = input<string>('');
  readonly isMandatoryJustification = input<boolean>(false);

  @Output() readonly onCloseClicked = new EventEmitter<void>();
  @Output() readonly onCancelClicked = new EventEmitter<void>();
  @Output() readonly descriptionChanged = new EventEmitter<string>();

  currentDescription: string = '';

  onClose(): void {
    this.onCloseClicked.emit();
  }

  onCancel(): void {
    this.onCancelClicked.emit();
  }

  onDescriptionChanged(event: Event): void {
    const text = (event.target as HTMLTextAreaElement).value;
    this.currentDescription = text;
    this.descriptionChanged.emit(text);
  }
}
